var _module_exports = "<div class=\"about\">\n  <div class=\"about__text\">\n    {{ $ctrl.about }}\n  </div>\n</div>\n";;
var path = '/workspace/src/app/components/expert-profile/expert-profile-view-modal/expert-profile-about/expert-profile-about.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;